import script from "./TableShows.vue?vue&type=script&setup=true&lang=js"
export * from "./TableShows.vue?vue&type=script&setup=true&lang=js"

import "./TableShows.vue?vue&type=style&index=0&id=1b19f8f6&lang=less&scoped=true"

import exportComponent from "/Users/april/Desktop/hz_pro_vue3/mail-task-front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1b19f8f6"]])

export default __exports__